import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'message-registrations';
var crud = createCrud(basePath);

/* Default queries */
export var useMessageRegistrationsCount = crud.makeCount();
export var useMessageRegistrationsById = crud.makeFindById();
export var useMessageRegistrationsByIds = crud.makeFindByIds();
export var useMessageRegistrationsMany = crud.makeFindMany();
export var useMessageRegistrationsOne = crud.makeFindOne();
export var useMessageRegistrationsPagination = crud.makePagination();

/* Default mutations */
export var useMessageRegistrationsCreateOne = crud.makeCreateOne();
export var useMessageRegistrationsUpdateOne = crud.makeUpdateOne();
export var useMessageRegistrationsRemoveById = crud.makeRemoveById();